// « S'exercer » (DRILL) — petit bouton icône chaussure de sport (~23 px, carré à bords arrondis),
// affiché sur un critère éligible dans les 3 points d'entrée. Tooltip « S'exercer sur ce critère ».
// À NE PAS confondre avec l'haltère de « S'entraîner » (simulations).

import shoeIcon from "../assets/drill-shoe.png";

type Props = {
  onClick: () => void;
  tooltip?: string;
  highlighted?: boolean; // critère conseillé par le coach (étoile au débrief)
  size?: number;
  // Placement du tooltip. Défaut "top" (au-dessus). Passer "bottom" quand l'icône est en HAUT
  // d'un conteneur `overflow` (ex. critères en tête du feedback) : au-dessus, le tooltip était
  // rogné par le bord du cadre et illisible.
  tooltipPlacement?: "top" | "bottom";
};

export function DrillIcon({ onClick, tooltip = "S'exercer sur ce critère", highlighted = false, size = 15, tooltipPlacement = "top" }: Props) {
  const box = size + 8;
  const tipPos = tooltipPlacement === "bottom" ? "top-full mt-2" : "bottom-full mb-2";
  return (
    <span className="group relative inline-flex">
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onClick(); }}
        aria-label={tooltip}
        title={tooltip}
        className="relative flex items-center justify-center rounded-lg border transition-all duration-150 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1"
        style={{
          height: box,
          width: box,
          borderColor: highlighted ? "#E3C27E" : "#C7D6E8",
          background: highlighted
            ? "linear-gradient(180deg, #FFFFFF 0%, #FBF1DC 100%)"
            : "linear-gradient(180deg, #FFFFFF 0%, #EEF4FB 100%)",
          boxShadow: highlighted
            ? "0 1px 2px rgba(138,100,22,.12), 0 4px 12px rgba(185,130,29,.18)"
            : "0 1px 2px rgba(46,67,104,.10), 0 4px 10px rgba(46,67,104,.07)",
        }}
      >
        <img src={shoeIcon} alt="" width={size} height={size} style={{ objectFit: "contain" }} />
      </button>
      <span
        className={`pointer-events-none absolute ${tipPos} left-1/2 z-30 -translate-x-1/2 whitespace-nowrap rounded-lg px-2.5 py-1.5 text-xs font-semibold text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100`}
        style={{ backgroundColor: highlighted ? "#8A6416" : "#2C4A6E" }}
      >
        {tooltip}
      </span>
    </span>
  );
}
